import script from "./Sprachtechnik-Leads.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Leads.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Leads.vue?vue&type=style&index=0&id=752e559a&scoped=true&lang=css"
import "./Sprachtechnik-Leads.vue?vue&type=style&index=1&id=752e559a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752e559a"]])

export default __exports__